export const TYPE_BOOLEAN_FILTER = 'TYPE_BOOLEAN_FILTER';
export const TYPE_COLLECTION_FILTER = 'TYPE_COLLECTION_FILTER';
export const TYPE_DATE_TIME_FILTER = 'TYPE_DATE_TIME_FILTER';
export const TYPE_NUMERIC_FILTER = 'TYPE_NUMERIC_FILTER';
export const TYPE_STRING_FILTER = 'TYPE_STRING_FILTER';
export const TYPE_TIME_FILTER = 'TYPE_TIME_FILTER';
